import { Box, Typography } from '@mui/material';
import { MdShowChart } from 'react-icons/md';
import { colors } from '../../../themes/muiTheme';
import { IChartEmptyState } from './ChartEmptyState.types';

const DEFAULT_MESSAGE = 'No data available for this period';
const DEFAULT_HEIGHT = 400;

const ChartEmptyState: React.FC<IChartEmptyState> = ({
  message = DEFAULT_MESSAGE,
  icon,
  height = DEFAULT_HEIGHT,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height,
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {icon || <MdShowChart size={48} color={colors.grey} style={{ opacity: 0.5 }} />}
      <Typography
        variant="body1"
        sx={{ color: colors.grey, textAlign: 'center' }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default ChartEmptyState;

